export const fetchRecommendedPosts = async (brand) => {
  try {
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (brand === "alvine") {
      return {
        instagram: {
          embedCode:
            '<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/p/DHd1rP5JTv1/" data-instgrm-version="14"></blockquote>',
          caption: "Essa música nasceu pra ser cantada pelas esquiletes!",
          link: "https://www.instagram.com/p/DHd1rP5JTv1/",
          brand: "alvine",
          imageUrl: "/social/instaalvin.png",
        },
        tiktok: {
          embedCode:
            '<blockquote class="tiktok-embed" cite="https://www.tiktok.com/@alvineosesquilosbr/video/7483996179907235127" data-video-id="7307275223037613349"></blockquote>',
          caption: "É o lugar onde eu consigo descansar!",
          link: "https://www.tiktok.com/@alvineosesquilosbr/video/7483996179907235127",
          brand: "alvine",
          imageUrl: "/social/tiktokalvin.png",
        },
        youtube: {
          embedCode:
            '<iframe width="100%" height="100%" src="https://www.youtube.com/watch?v=-4jE0VelgWs" title="Alvin e os Esquilos" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
          caption: "Off to See the World - \"As Aventuras dos Chipmunk\"",
          link: "https://www.youtube.com/watch?v=-4jE0VelgWs",
          brand: "alvine",
          imageUrl: "/social/ytalvin.jpg",
        },
      };
    } else {
      return {
        instagram: {
          embedCode:
            '<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/p/DCgKWV9OLQI/" data-instgrm-version="14"></blockquote>',
          caption: "Behind the scenes - Alvin and the Chipmunks (2007)", 
          link: "https://www.instagram.com/p/DCgKWV9OLQI/",
          brand: "munk",
          imageUrl: "/social/instamysf.jpg",
        },
        tiktok: {
          embedCode:
            '<blockquote class="tiktok-embed" cite="https://www.tiktok.com/@munkyourself/video/7255485592397563178" data-video-id="7255485592397563178"></blockquote>',
          caption: "Simon Animation Test",
          link: "https://www.tiktok.com/@munkyourself/video/7255485592397563178",
          brand: "munk",
          imageUrl: "/social/tiktokmysf.png",
        },
        youtube: {
          embedCode:
            '<iframe width="100%" height="100%" src="https://www.youtube.com/watch?v=SVBzPjRKvBc" title="Munk Yourself" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
          caption: "Voice Recording Sessions - Chipwrecked",
          link: "https://www.youtube.com/watch?v=SVBzPjRKvBc",
          brand: "munk",
          imageUrl: "/social/ytmysf.jpg",
        },
      };
    }
  } catch (error) {
    console.error(`Erro ao carregar posts recomendados para ${brand}:`, error);
    throw error;
  }
};
